import client from "lib/apolloClient/client";
import {
  getStudentPortfolioInsightsProjectsQuery,
  getLearningOutcomesWithEvidencesInsightsQuery,
} from "./StudentPortfolioInsightsQueries";

export const getStudentPortfolioInsightsProjectsFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentPortfolioInsightsProjectsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const getStudentLearningOutcomesInsightsFromCache = ({ variables }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getLearningOutcomesWithEvidencesInsightsQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return queryData ? queryData : {};
};

export const writeLearningOutcomesInsightsWithEvidencesInCache = ({
  id,
  data,
  plannerElementEvidenceFilters,
  isServiceAsAction,
}) => {
  let queryData = {};
  try {
    queryData = client.writeQuery({
      query: getLearningOutcomesWithEvidencesInsightsQuery,
      variables: {
        id,
        plannerElementEvidenceFilters,
        isServiceAsAction,
      },
      data,
    });
  } catch (e) {
    return {};
  }
  return queryData ? queryData : {};
};
